import React, { useEffect, useState } from "react";

const DEFAULT_OPTIONS = {
  applyRules: true,
  minCharacters: 3400,
  minHeadings: 4,
  requireBullets: true,
  extraInstruction: ""
};

export default function AiAssistOptionsModal({ open, mode, onClose, onSubmit }) {
  const [options, setOptions] = useState(DEFAULT_OPTIONS);

  useEffect(() => {
    if (open) {
      setOptions(DEFAULT_OPTIONS);
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="ai-options-modal-backdrop"
      role="dialog"
      aria-modal="true"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="ai-options-modal" onMouseDown={(event) => event.stopPropagation()}>
        <button type="button" className="ai-options-modal-close" onClick={onClose} aria-label="Close AI options dialog">
          ×
        </button>
        <div className="ai-options-modal-head">
          <h4>{mode === "rewrite" ? "AI Rewrite Options" : "AI Generate Options"}</h4>
        </div>
        <p className="muted ai-options-intro">
          Configure optional structure rules for this run only. These options do not permanently change policy.
        </p>

        <label className="ai-option-row ai-option-switch">
          <input
            type="checkbox"
            checked={options.applyRules}
            onChange={(event) => setOptions((prev) => ({ ...prev, applyRules: event.target.checked }))}
          />
          <span>Apply structured content rules</span>
        </label>

        <div className="inline-grid two ai-option-grid">
          <label>
            <span>Minimum Characters</span>
            <input
              type="number"
              min="100"
              value={options.minCharacters}
              onChange={(event) => setOptions((prev) => ({ ...prev, minCharacters: Number(event.target.value || 0) }))}
              disabled={!options.applyRules}
            />
          </label>
          <label>
            <span>Minimum Headings</span>
            <input
              type="number"
              min="1"
              value={options.minHeadings}
              onChange={(event) => setOptions((prev) => ({ ...prev, minHeadings: Number(event.target.value || 0) }))}
              disabled={!options.applyRules}
            />
          </label>
        </div>

        <label className="ai-option-row ai-option-switch">
          <input
            type="checkbox"
            checked={options.requireBullets}
            onChange={(event) => setOptions((prev) => ({ ...prev, requireBullets: event.target.checked }))}
            disabled={!options.applyRules}
          />
          <span>Require bullet points under headings</span>
        </label>

        <label className="ai-option-extra">
          <span>Extra Instruction (optional)</span>
          <textarea
            rows={3}
            value={options.extraInstruction}
            onChange={(event) => setOptions((prev) => ({ ...prev, extraInstruction: event.target.value }))}
            placeholder="Any extra tone/structure guidance..."
            disabled={!options.applyRules}
          />
        </label>

        <div className="hero-actions">
          <button type="button" className="button-link ghost" onClick={onClose}>Cancel</button>
          <button type="button" className="button-link" onClick={() => onSubmit(options)}>
            {mode === "rewrite" ? "Run Rewrite" : "Run Generate"}
          </button>
        </div>
      </div>
    </div>
  );
}
